// Collection/search filter re-renders always call window.scrollTo({behavior:'smooth'})
// to the grid top, even when the grid is already in view. Combined with the DOM
// swap/reflow that happens at the same time, this produced a janky "slow-motion"
// scroll on every filter click. Guard here (rather than only in theme.unmin.js)
// so the fix survives theme re-syncs that overwrite theme.unmin.js.
(function () {
  const nativeScrollTo = window.scrollTo.bind(window);
  window.scrollTo = function (...args) {
    const opts = args[0];
    if (args.length === 1 && opts && typeof opts === 'object' && opts.behavior === 'smooth') {
      const target = typeof opts.top === 'number' ? opts.top : window.pageYOffset;
      if (Math.abs(window.pageYOffset - target) <= 80) return;
    }
    return nativeScrollTo(...args);
  };
})();

// Collection filter checkbox/range changes are debounced ~1s before the
// collection grid actually re-fetches, which made the ".collection__loading"
// spinner only appear after that delay. Show it immediately on interaction so
// there's no perceived "dead" gap between the click and the loading state.
// (Fallback in case the matching fix in theme.unmin.js gets overwritten by a
// theme re-sync from theme.min.js.)
document.addEventListener(
  'change',
  function (evt) {
    const target = evt.target;
    if (!target || !target.matches) return;
    const isFilterInput = target.matches(
      '.filter-item__checkbox, .filter-item__radio, .filter-input__input, .filter-drawer__price-range-input',
    );
    if (!isFilterInput) return;

    document.querySelectorAll('.collection__loading').forEach(function (el) {
      el.classList.add('is-active');
    });
  },
  true,
);
